export default "__VITE_ASSET__6_6mzrd___"